<div
  class="list-container"
  [ngClass]="{
    'max-files-reached': $safeNavigationMigration(images?.length) >= maxItems,
    'single-photo': maxItems === 1,
  }"
>
  @if (images?.length < maxItems) {
    <label
      class="upload-file cta-btn"
      [class.drag-over]="dragOver"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onFilesDropped($event)"
    >
      <div class="info">
        <p>
          {{ fileNoteKey | transloco }} <strong>{{ maxFileSize }}Mb</strong>
        </p>
        <div class="icon" [inlineSVG]="'/icons/icon-upload-no-color.svg'"></div>
        @if (showImgNote) {
          <p>
            {{ 'upload.upload_img_note' | transloco }} <strong>{{ maxImgRes }}px</strong>
          </p>
        }
      </div>
      <input #inputFiles type="file" (change)="onFileChange($event)" multiple="multiple" [accept]="fileTypesString" />
    </label>
  }

  @for (image of images; track image; let i = $index) {
    <div class="drag-drop-box">
      <div class="photo" [lazyLoad]="previewUrl(image?.url1x)">
        @if (i !== 0) {
          <button class="upload-list-btn btn-remove" type="button" (click)="setAsFirst(image)">
            <span class="icon-photo top" [inlineSVG]="'/icons/icon-to-the-top.svg'"></span>
          </button>
        }
        <button class="upload-list-btn btn-close" type="button" (click)="removeImage(image)">
          <span class="icon-photo" [inlineSVG]="'/icons/icon-x-small-no-color.svg'"></span>
        </button>
      </div>
    </div>
  }
</div>

@if (error) {
  <div class="upload-error">{{ 'form.error.' + error | transloco }}</div>
}
